"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _getNextStepValues = _interopRequireDefault(require("./helpers/getNextStepValues"));

var _getElementX = _interopRequireDefault(require("./helpers/getElementX"));

var _getNextHandlePositionFromValue = _interopRequireDefault(require("./helpers/getNextHandlePositionFromValue"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var EventHandler = /*#__PURE__*/function () {
  function EventHandler(setStateValues) {
    (0, _classCallCheck2["default"])(this, EventHandler);
    this.setStateValues = setStateValues;
    this.displayName = 'RangeInputEventHandler';
    this.steps = null;
    this.handleId = null;
    this.trackId = null;
    this.trackIdBounds = null;
    this.trackWidth = null;
    this.trackOffset = null;
    this.currentEventHandlePosition = 0;
    this.currentMousePosition = 0;
    this.handleEnd = this.handleEnd.bind(this);
    this.handleMove = this.handleMove.bind(this);
    this.isTouch = false;
  }

  (0, _createClass2["default"])(EventHandler, [{
    key: "onChange",
    value: function onChange(event, steps) {
      var currentHandlePosition = (0, _getNextHandlePositionFromValue["default"])(event.target.value, steps);
      this.setStateValues({
        currentHandlePosition: currentHandlePosition,
        dirty: true,
        complete: true,
        storedValue: Number(event.target.value)
      });
    }
  }, {
    key: "onMouseDown",
    value: function onMouseDown(event, steps, handleId, trackId) {
      event.preventDefault();
      this.isTouch = event.type === 'touchstart';
      this.handleId = handleId.current;
      this.trackId = trackId.current;
      this.trackIdBounds = this.getTrackIdBounds();
      this.trackWidth = this.trackIdBounds.width;
      this.trackOffset = this.trackIdBounds.x;
      this.currentEventHandlePosition = parseInt(this.handleId.style.left, 10);
      this.currentMousePosition = this.trackOffset - event.clientX;
      this.steps = steps;
      this.setListeners();
      this.handleMove(event);
    }
  }, {
    key: "setListeners",
    value: function setListeners() {
      switch (this.isTouch) {
        case true:
          document.addEventListener('touchmove', this.handleMove);
          document.addEventListener('touchend', this.handleEnd);
          break;

        default:
          document.addEventListener('mousemove', this.handleMove);
          document.addEventListener('mouseup', this.handleEnd);
      }
    }
  }, {
    key: "removeListeners",
    value: function removeListeners() {
      switch (this.isTouch) {
        case true:
          document.removeEventListener('touchmove', this.handleMove);
          document.removeEventListener('touchend', this.handleEnd);
          break;

        default:
          document.removeEventListener('mousemove', this.handleMove);
          document.removeEventListener('mouseup', this.handleEnd);
      }
    }
  }, {
    key: "handleEnd",
    value: function handleEnd() {
      this.removeListeners();
      this.setStateValues({
        active: false
      });
    }
  }, {
    key: "handleResize",
    value: function handleResize(value, steps) {
      var currentHandlePosition = (0, _getNextHandlePositionFromValue["default"])(value, steps);
      this.setStateValues({
        currentHandlePosition: currentHandlePosition
      });
    }
  }, {
    key: "getEventPosition",
    value: function getEventPosition(event) {
      switch (this.isTouch) {
        case true:
          return event.touches[0].clientX - this.trackOffset;

        default:
          return event.clientX - this.trackOffset;
      }
    }
  }, {
    key: "getTrackIdBounds",
    value: function getTrackIdBounds() {
      var bounds = this.trackId.getBoundingClientRect();

      if (bounds.x) {
        return bounds;
      }

      return _objectSpread(_objectSpread({}, bounds), {}, {
        // eslint-disable-next-line id-length
        x: bounds.left ? bounds.left : (0, _getElementX["default"])(this.trackId)
      });
    }
  }, {
    key: "handleMove",
    value: function handleMove(event) {
      var eventPosition = this.getEventPosition(event);

      if (eventPosition === this.currentPosition) {
        return false;
      }

      this.setStateValues({
        active: true
      });
      var direction = eventPosition <= this.currentPosition ? 'left' : 'right';
      var threshold = this.steps[0].threshold;

      switch (direction) {
        case 'right':
          if (eventPosition > this.currentEventHandlePosition + threshold) {
            var stepValues = (0, _getNextStepValues["default"])(eventPosition, direction, this.steps);
            this.currentEventHandlePosition = stepValues.pixels;
            this.setStateValues({
              currentHandlePosition: this.currentEventHandlePosition,
              storedValue: stepValues.value
            });
          }

          break;

        default:
          if (eventPosition < this.currentEventHandlePosition - threshold) {
            var _stepValues = (0, _getNextStepValues["default"])(eventPosition, direction, this.steps);

            this.currentEventHandlePosition = _stepValues.pixels;
            this.setStateValues({
              currentHandlePosition: this.currentEventHandlePosition,
              storedValue: _stepValues.value
            });
          }

      }

      this.currentPosition = eventPosition;
      return true;
    }
  }]);
  return EventHandler;
}();

var _default = EventHandler;
exports["default"] = _default;